import moment from "moment";
import React, { FC, useEffect, useRef, useState } from "react";
import { useIntl } from "react-intl";
import { DEFAULT_PER_PAGE } from "../../constants/common";
import { HeaderModel, ModalModel } from "../../models/CommonModel";
import { PaginateModel } from "../../models/PaginateModel";
import { ReceiptDetailModel, ReceiptDetailSearchModel } from "../../models/ReceiptDetailModel";
import { download } from "../../modules/common/helper";
import { AsyncSelect2Supplier } from "../../../_metronic/partials/select/AsyncSelect2Supplier";
import { ADMIN_STORES_ENDPOINT, GET_CONSIGNMENT_SUPPLIER_OPTIONS } from "../../constants/endpoints";
import ReceiptProductsTable from "./ReceiptProductsTable";
import Flatpickr from "react-flatpickr";
import {Vietnamese} from "flatpickr/dist/l10n/vn.js"
import { exportSearchProduct, searchProduct } from "./ReceiptCRUD";
import AsyncSelect from "react-select/async";
import { AsyncSelect2 } from "../../../_metronic/partials/select/AsyncSelect2";
import { PaginationLength } from "../../../_metronic/partials/pagination/PaginationLength";
import { Paginate } from "../../../_metronic/partials/pagination/Paginate";
import { PaginationHeader } from "../../../_metronic/partials/pagination/PaginationHeader";
import { formatPrice } from "../../selectors";

const ReceiptProducts: FC = () => {
  const intl = useIntl()
  const initRange: any = [moment().startOf('month').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')]
  const initSearch = {
    page: 1,
    per_page: DEFAULT_PER_PAGE,
    date: {startDate: initRange[0], endDate: initRange[1]},
    receipt_type: 1
  }
  const [configModal, setConfigModal] = useState<ModalModel>({
    show: false,
    mode: 'add',
  });
  const fp = useRef<any>(null);
  const supplierRef = useRef<any>(null);
  const [hideCols, setHideCols] = useState<string[]>([]);
  const [dataPaginate, setDataPaginate] = useState<PaginateModel<ReceiptDetailModel>>()
  const [subTotal, setSubTotal] = useState<number>(0);
  const [search, setSearch] = useState<ReceiptDetailSearchModel>(initSearch)

  useEffect(() => {
    document.title = 'Sento - Sản phẩm ký gửi đã bán';
  })

  useEffect(() => {
    getData(initSearch)
  }, []);

  const header: HeaderModel[] = [
    {
      label: 'Tên sản phẩm',
      style: {},
      field: 'inventory_name',
      sortable: true
    },
    {
      label: 'Nhà cung cấp',
      style: { minWidth: "150px" },
      field: 'supplier_name',
      sortable: true
    },
    {
      label: 'Số lượng',
      style: { minWidth: "50px" },
      field: 'quantity',
      sortable: true
    },
    {
      label: 'Đơn vị',
      style: { minWidth: "80px" },
      field: 'unit',
      sortable: false
    },
    {
      label: 'Đơn giá',
      style: { minWidth: "80px" },
      field: 'price',
      sortable: true
    },
    {
      label: 'VAT',
      style: { minWidth: "50px" },
      field: 'vat',
      sortable: true
    },
    {
      label: 'Tổng giá trị',
      style: { minWidth: "80px" },
      field: 'sub_total',
      sortable: true
    },
    {
      label: 'Mã đơn',
      style: { minWidth: "100px" },
      field: 'receipt_code',
      sortable: true
    },
    {
      label: 'Ngày duyệt',
      style: { minWidth: "120px" },
      field: 'approved_at',
      sortable: true
    }
  ];

  const getData = async (params: ReceiptDetailSearchModel) => {

    const { data: dataPaginate } = await searchProduct(params);
    const objQuery = { ...params }
    if (objQuery.page === 1) {
      delete objQuery.page
    }
    if (objQuery.per_page === DEFAULT_PER_PAGE) {
      delete objQuery.per_page
    }
    setDataPaginate(dataPaginate?.paginate_data);
    setSubTotal(dataPaginate?.sub_total ?? 0);
    setSearch(params ?? {});
  }
  
  const handleChangeVisCols = (e: any) => {
    let hiddenCols = [...hideCols];
    if (!e.target?.checked) {
      setHideCols([...hiddenCols, e.target.name])
    } else {
      setHideCols(hiddenCols.filter((item) => item !== e.target.name))
    }
  }

  const handleSearch = (e: any) => {
      e.preventDefault();
      getData({ ...search, page: 1 })
  }

  const handlePageLengthChange = (e: any) => {
    getData({ ...search, page: 1, per_page: +e.target.value })
  }

  const handlePageChange = (data: any) => {
    getData({ ...search, page: data.selected + 1 })
  }

  const handleSort = (sortBy: string, direction: 'asc' | 'desc' | 'none') => {
    const currentSearch = { ...search };
    const sortParams: ReceiptDetailSearchModel = { ...currentSearch, sort_by: sortBy, sort_direction: direction };
    if (direction === 'none') {
      delete sortParams.sort_by;
      delete sortParams.sort_direction;
    }
    getData({ ...sortParams });
  }

  const handleKeyDown = (e: any) => {
    if (e.key === 'Enter') {
        handleSearch(e);
    }
  }

  const handleClearSearch = (e: any) => {
    e.preventDefault();
    supplierRef?.current?.clearValue()
    setSearch({
      ...initSearch,
      date: {startDate: null, endDate: null}
    });
    if (fp.current?.flatpickr) {
      fp.current.flatpickr.clear();
    }
    getData({...initSearch})
  }

  const handleExport = async () => {
    const {data} = await exportSearchProduct({...search});
    download(data, 'search_product');
  }

  return (
      <div className="card">
        <div className="card-header py-4">
          <div className="col-md-12">
            <form onSubmit={handleSearch}>
              <div className="row">
                <div className="col-md-3">
                  <label className="form-label">Nhà cung cấp</label>
                  <AsyncSelect2Supplier
                    name="supplier"
                    placeholder=""
                    sourceUrl={GET_CONSIGNMENT_SUPPLIER_OPTIONS}
                    defaultOptions
                    default
                    storeId={search?.store_id}
                    value={{value: search?.supplier_id ?? '', label: search?.supplier_name ?? 'Tất cả'}}
                    onChange={(selectedOption: any) => {
                        setSearch({...search, supplier_id:  selectedOption.value, supplier_name: selectedOption.label})
                    }}
                />
                </div>
                <div className="col-md-3">
                  <label className="form-label">Cửa hàng</label>
                  <AsyncSelect2
                    sourceUrl={`${ADMIN_STORES_ENDPOINT}`}
                    defaultOptions
                    default
                    onChange={(selectedOption: any) => {
                        setSearch({...search, store_id:  selectedOption.value});
                    }}
                  />
                </div>
                <div className="col-md-2">
                  <label className="form-label">Tên sản phẩm</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder=""
                    name="name"
                    value={search.name || ''}
                    onChange={(e) => setSearch({ ...search, name: e.target.value })}
                    autoComplete='nope'
                    onKeyDown={(e) => handleKeyDown(e)}
                  />
                </div>
                <div className='col-md-3 mb-2'>
                  <label className="form-label">Ngày</label>
                  <Flatpickr
                    ref={fp}
                    onChange={(date) => {
                      let startDate = moment(date[0]).format('YYYY-MM-DD');
                      let endDate = moment(date[1]).format('YYYY-MM-DD');
                      setSearch({...search, date: {startDate, endDate}});
                    }}
                    options={{
                      mode: "range",
                      dateFormat: "d-m-Y",
                      locale: Vietnamese,
                      shorthandCurrentMonth: true,
                      defaultDate: [moment().startOf('month').format('DD-MM-YYYY'), moment().format('DD-MM-YYYY')],
                    }}
                    className='form-control'
                    placeholder=''
                  />
                </div>
                <div className="col-md-4">
                  <div className="row">
                    <button
                      className="col-auto btn btn-primary mt-8 me-2"
                      onClick={handleSearch}
                    >
                      <i className="bi bi bi-search fs-4"></i> {intl.formatMessage({ id: 'COMMON.SEARCH' })}
                    </button>
                    <button
                      className="col-auto btn btn-danger mt-8 me-2"
                      type="button"
                      onClick={handleClearSearch}
                    >
                      <i className="bi bi-eraser-fill fs-1"></i> Re-search
                    </button>
                  </div>

                </div>
              </div>
            </form>
          </div>
        </div>
        <div className="card-body">
          <div className="justify-content-between align-items-center my-3 row">
            <div className='col-md-5'>
                <PaginationHeader from={dataPaginate?.meta?.from || 0} to={dataPaginate?.meta?.to || 0}
                    total={dataPaginate?.meta?.total || 0} />
                <h3>Tổng cộng: <span className="text-bold">{formatPrice(subTotal)} VNĐ</span></h3>
            </div>
            <div className='col-md-7 btns-group text-end'>
              <button type="button" className="btn btn-primary btn-sm mx-1 mt-1" onClick={() => handleExport()}>
                  <i className="bi bi bi-cloud-arrow-down-fill"></i> {intl.formatMessage({ id: 'COMMON.EXPORT' }, { name: '' })}
              </button>
          </div>
          </div>
          <ReceiptProductsTable
            data={dataPaginate?.data || []}
            openColConfig={() => setConfigModal({ ...configModal, show: true })}
            header={header}
            hideCols={hideCols}
            handleSort={handleSort}
          />
        </div>
         <div className="card-footer d-flex justify-content-between paginate-wrapper">
            <PaginationLength selected={search.per_page || DEFAULT_PER_PAGE} onChange={handlePageLengthChange} />
            <Paginate
                pageCount={dataPaginate?.meta?.last_page || 0}
                onPageChange={handlePageChange}
                forcePage={(search.page || 1) - 1}
            />
        </div>
      </div>
  )
}
export default ReceiptProducts